import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=52cf28b8&lang=pug"
import script from "./HomeHero.vue?vue&type=script&lang=js"
export * from "./HomeHero.vue?vue&type=script&lang=js"
import style0 from "./HomeHero.vue?vue&type=style&index=0&id=52cf28b8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports